import React from 'react'
import { formatMoney } from '../../features/utils/formatMoney';
import { getAgeType } from '../../utils/booking/getAgeType';

export default function ChangePriceBreakdown({data}) {
    console.log(data)
    const priceBreakdown = data?.priceBreakdown?.map(obj => ({...obj,
        passengerInfo: data?.passengerInfo?.find(passenger => passenger?.id === obj?.passengerId)
    }));
  return (
    <div className='p-4 bg-primary/5 flex flex-col gap-4'>
      {priceBreakdown?.map((obj,i) => (
        <div key={i}>
            <div className='flex gap-4 items-center justify-between'>
                <b className='capitalize'>
                    Passenger {i+1} ({getAgeType(obj?.passengerInfo?.travelerType)})
                </b>
                <b>{formatMoney(obj?.changeFee + obj?.changePrice + obj?.penaltyFee + obj?.ticketDifference)}</b>
            </div>
            <div className='px-4 py-1 pr-0'>
                <div className='flex justify-between items-center gap-4'>
                    <p>Change fee</p>
                    <p>{formatMoney(obj?.changeFee)}</p>
                </div>
                <div className='flex justify-between items-center gap-4'>
                    <p>Change price</p>
                    <p>{formatMoney(obj?.changePrice)}</p>
                </div>
                <div className='flex justify-between items-center gap-4'>
                    <p>Ticket Difference</p>
                    <p>{formatMoney(obj?.ticketDifference)}</p>
                </div>
                <div className='flex justify-between items-center gap-4'>
                    <p>Penality</p>
                    <p>{formatMoney(obj?.penaltyFee)}</p>
                </div>
            </div>
        </div>
      ))}
      <hr />
      <div className='flex gap-4 items-center justify-between'>
        <b>Total</b>
        <b>{formatMoney(data?.payable)}</b>
      </div>
    </div>
  )
}
